export const formatShortWeekday = (locale, date) => {
  const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  return dayNames[date.getDay()];
};
